import _createPlugin from "./lib/public/create-plugin";
var exports = {};
let createPlugin = _createPlugin;
exports = (createPlugin.__esModule ? createPlugin : {
  default: createPlugin
}).default;
export default exports;